import React from "react";
import PaginaLocal from "../components/PaginaLocal";
import Perguntas from "../components/Perguntas";
import { Itens, OutrosServicos, LinkSeta } from "../components/Blocos";
import { Mapa, Distancias } from "../components/Mapa";
import { locais } from "../components/data/locais";

const local = locais.regiao;

const blocos = [
  {
    chave: "mapa",
    rotulo: local.mapa.rotulo,
    titulo: local.mapa.titulo,
    texto: local.mapa.texto,
    conteudo: (
      <>
        <figure className="max-w-3xl mx-auto mb-16 xl:mb-24">
          <Mapa titulo="Mapa do sul de Santa Catarina com Orleans no centro e as cidades atendidas pela Hawx em destaque" />
          <figcaption className="text-sm text-gray-600 mt-4 text-center">{local.mapa.legenda}</figcaption>
        </figure>
        <Distancias />
        <div className="xl:text-center mt-10">
          <LinkSeta href="/software-em-orleans-sc">Sistemas e software em Orleans</LinkSeta>
        </div>
      </>
    ),
  },
  { chave: "metodo", rotulo: local.metodo.rotulo, titulo: local.metodo.titulo, azul: true, conteudo: <Itens secao={local.metodo} claro /> },
  { chave: "perguntas", rotulo: "Dúvidas", titulo: "Perguntas sobre o atendimento", conteudo: <Perguntas perguntas={local.perguntas} /> },
  { chave: "servicos", rotulo: "Serviços", titulo: "O que fazemos", conteudo: <OutrosServicos /> },
];

const OndeAtendemos = () => <PaginaLocal local={local} blocos={blocos} />;

export default OndeAtendemos;
